<template>
  <div class="uni-promotion-new-page">
    <common-table
      :limitHeight="true"
      :table-columns="tableColumns"
      pageName="UniPromotionNew"
      :url="url"
      :operate="operate"
      :saveSelectObj="saveSelectObj"
      :savePromotionConfigObj="savePromotionConfigObj"
      :searchs="searchs"
      :operateLength="250"
      :form-fields="formFields"
      :permission="permission"
      :route_params="route_params"
      @selectProduct="selectProduct"
      @selectChange="selectChange"
      @openPromotionConfig="openPromotionConfig"
      @isPageSmall="isPageSmall"
    />

    <el-drawer
      :visible.sync="showSelectProductPopup"
      :size="pageSmall ? '100%' : '50%'"
      direction="rtl"
      :with-header="false"
    >
      <div class="drawer_title">选择商品</div>
      <div class="p20 pt30 product-drawer-body">
        <div class="font-bold pb20">
          在巨量千川全域推广任务中，若执行商品新增或商品修改操作，将触发任务全量更新，此过程可能导致素材丢失，请谨慎操作并提前做好素材备份。
        </div>
        <div class="flex-between pl20">
          <div class="fs13 c_999">
            支持搜索商品名称/ID，多选后统一保存到当前账户配置。
          </div>
          <div class="flex alcenter fs14">
            <el-checkbox
              v-model="isSelect30"
              :style="pageSmall ? 'display:flex;align-items:center;' : 'transform:scale(1.2);display:flex;align-items:center;'"
              @change="isCheckedChange"
            >
              点击选择前30条
            </el-checkbox>
          </div>
        </div>
        <div class="mt20 search-row">
          <el-input
            v-model.trim="productSearchText"
            class="search-input"
            clearable
            placeholder="请输入商品名称/ID搜索"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div class="selected-counter">已选 {{ selectedList.length }}/30</div>
        </div>
        <div class="mt20 product-table-section">
          <el-table
            ref="prodcutTable"
            v-loading="loading"
            :row-class-name="'row-pointer'"
            :data="filteredProductTableData"
            :height="getProductTableHeight()"
            border
            style="width: 100%"
            header-cell-class-name="header_className"
            @row-click="rowClick"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="productInfo" label="商品信息" width="400" align="left">
              <template slot-scope="scope">
                <div class="add_product_box flex alcenter">
                  <img :src="scope.row.img || scope.row.productImage" alt="">
                  <div class="pl10">
                    <div class="overflow1">{{ scope.row.productName }}</div>
                    <div class="overflow1 c_999">ID:{{ scope.row.productId }}</div>
                    <div class="overflow1 c_999">价格 {{ scope.row.price || '--' }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="标签" width="150">
              <template slot-scope="scope">
                <el-tag class="mt5" v-for="(item, index) in scope.row.tagArr" :key="index">
                  {{ item }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" label="类目" width="150"></el-table-column>
            <el-table-column prop="sellNum" label="销量"></el-table-column>
            <el-table-column prop="address" label="库存"></el-table-column>
          </el-table>
          <div
            class="flex-center pt20"
            :class="{ 'c_346bf6': hasMore }"
            @click="loadMoreProducts"
          >
            {{ hasMore ? '点击加载更多' : '暂无更多' }}
          </div>
        </div>
        <div class="footer_box flex-between">
          <div class="flex alcenter pr5">
            已选:{{ selectedList.length }}
            <div class="flex alcenter selectedListBox">
              <div class="relative ml10" v-for="(item, index) in selectedList" :key="item.productId || index">
                <img :src="item && item.img || item.productImage" alt="">
                <i class="el-icon-error" @click="toggleRowSelection(item, index)"></i>
              </div>
            </div>
          </div>
          <div class="flex alcenter">
            <el-button class="flex-center responsiveButton" round @click="saveProduct(0)">取消</el-button>
            <el-button class="flex-center responsiveButton" type="primary" round @click="saveProduct(1)">
              保存商品
            </el-button>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      :visible.sync="showPromotionConfigDrawer"
      :size="pageSmall ? '100%' : '78%'"
      direction="rtl"
      :with-header="false"
      custom-class="promotion-config-drawer"
    >
      <div class="drawer_title">配置投放</div>
      <div class="promotion-config-wrapper">
        <div class="promotion-config-main">
          <div class="step-card">
            <div class="step-header">
              <div class="step-index">1</div>
              <div>
                <div class="step-title">选择商品</div>
                <div class="step-subtitle">保留批量账户能力，每个账户单独配置商品与素材</div>
              </div>
            </div>
            <div class="account-summary">
              <div class="summary-item">
                <span class="summary-label">广告账户</span>
                <span class="summary-value">{{ currentRowAccountName }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">抖音号</span>
                <span class="summary-value">{{ currentRowDyName }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">已选商品</span>
                <span class="summary-value">{{ promotionConfigProducts.length }}/30</span>
              </div>
            </div>
            <div class="goods-toolbar">
              <el-button type="primary" icon="el-icon-plus" @click="openProductDrawerFromConfig">
                添加商品
              </el-button>
              <span class="goods-tip">支持在当前账户下多选商品，保存后回写到批量列表。</span>
            </div>
            <div class="goods-grid" v-if="promotionConfigProducts.length">
              <div
                v-for="product in promotionConfigProducts"
                :key="product.productId"
                class="goods-card"
                :class="{ active: currentConfigProductId === product.productId }"
                @click="switchConfigProduct(product.productId)"
              >
                <img :src="product.productImage || product.img" alt="">
                <div class="goods-card-content">
                  <div class="goods-name">{{ product.productName }}</div>
                  <div class="goods-id">ID:{{ product.productId }}</div>
                  <div class="goods-status" :class="getProductStatusClass(product.productId)">
                    {{ getProductStatusText(product.productId) }}
                  </div>
                </div>
              </div>
            </div>
            <el-empty v-else description="请先为当前账户选择商品"></el-empty>
          </div>

          <div class="step-card">
            <div class="step-header">
              <div class="step-index">2</div>
              <div>
                <div class="step-title">投放设置</div>
                <div class="step-subtitle">首期仅支持控成本投放，字段与当前后端能力保持一致</div>
              </div>
            </div>
            <div class="delivery-mode-grid">
              <div class="delivery-mode-card active">
                <div class="delivery-mode-title">控成本投放</div>
                <div class="delivery-mode-desc">使用净成交 ROI 目标控制成本，适合当前系统批量创建主链路。</div>
              </div>
              <div class="delivery-mode-card disabled">
                <div class="delivery-mode-title">放量投放</div>
                <div class="delivery-mode-desc">敬请期待，当前版本暂不开放。</div>
              </div>
            </div>
            <div class="budget-grid">
              <div class="budget-item">
                <div class="budget-label">日预算</div>
                <el-input-number
                  v-model="promotionConfigForm.dayBudget"
                  :min="300"
                  :max="999999999.99"
                  :precision="2"
                  :step="100"
                  controls-position="right"
                  class="budget-input"
                ></el-input-number>
                <div class="field-tip">范围 300 - 999999999.99 元</div>
              </div>
              <div class="budget-item">
                <div class="budget-label">净成交 ROI 目标</div>
                <el-input-number
                  v-model="promotionConfigForm.roiTarget"
                  :min="0.01"
                  :max="10000"
                  :precision="2"
                  :step="0.1"
                  controls-position="right"
                  class="budget-input"
                ></el-input-number>
                <div class="field-tip">范围 0.01 - 10000</div>
              </div>
            </div>
            <div class="schedule-block">
              <div class="budget-label">投放时间</div>
              <el-radio-group v-model="promotionConfigForm.scheduleType">
                <el-radio-button label="LONG_TERM">从今天起长期投放</el-radio-button>
                <el-radio-button label="CUSTOM">设置开始和结束日期</el-radio-button>
              </el-radio-group>
              <div class="mt15" v-if="promotionConfigForm.scheduleType === 'CUSTOM'">
                <el-date-picker
                  v-model="promotionConfigForm.timeRange"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="time-range-picker"
                ></el-date-picker>
              </div>
            </div>
          </div>

          <div class="step-card">
            <div class="step-header">
              <div class="step-index">3</div>
              <div>
                <div class="step-title">素材设置</div>
                <div class="step-subtitle">支持自动素材和自选素材；未手动配置的商品将按商品ID自动匹配抖音主页视频</div>
              </div>
            </div>
            <div class="material-mode-grid">
              <div
                class="material-mode-card"
                :class="{ active: promotionConfigForm.materialMode === 'AUTO' }"
                @click="selectMaterialMode('AUTO')"
              >
                <div class="material-mode-title">自动素材</div>
                <div class="material-mode-desc">继续沿用后端自动拉取素材逻辑，兼容现有批量创建方式。</div>
              </div>
              <div
                class="material-mode-card"
                :class="{ active: promotionConfigForm.materialMode === 'MANUAL', disabled: isNoAwemeMerchant() }"
                @click="selectMaterialMode('MANUAL')"
              >
                <div class="material-mode-title">自选素材</div>
                <div class="material-mode-desc">前端选择每个商品的投放视频与标题；无号商家仅支持商品卡投放。</div>
              </div>
            </div>

            <div v-if="promotionConfigForm.materialMode === 'AUTO'" class="auto-material-box">
              <i class="el-icon-magic-stick"></i>
              <span>{{ isNoAwemeMerchant() ? '无号商家将按官方规则使用商品卡方图创建计划，不支持视频素材。' : '当前账户将继续使用系统自动素材，批量创建时不会额外要求素材选择。' }}</span>
            </div>

            <div v-else class="manual-material-layout">
              <div class="manual-material-main">
                <div class="manual-product-tabs">
                  <div
                    v-for="product in promotionConfigProducts"
                    :key="product.productId"
                    class="manual-product-tab"
                    :class="{ active: currentConfigProductId === product.productId }"
                    @click="switchConfigProduct(product.productId)"
                  >
                    <img :src="product.productImage || product.img" alt="">
                    <div class="manual-product-meta">
                      <div class="manual-product-name">{{ product.productName }}</div>
                      <div class="manual-product-status" :class="getProductStatusClass(product.productId)">
                        {{ getProductStatusText(product.productId) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="currentConfigProduct" class="material-editor">
                  <div class="material-editor-header">
                    <div>
                      <div class="editor-title">当前商品素材</div>
                      <div class="editor-subtitle">
                        商品ID：{{ currentConfigProduct.productId }}，每个商品首期需选择 1 条视频素材
                      </div>
                    </div>
                    <div class="editor-actions">
                      <el-button type="primary" icon="el-icon-video-play" @click="openMaterialDialog(currentConfigProduct)">
                        选择视频素材
                      </el-button>
                      <el-button
                        v-if="hasSelectedCreative(currentConfigProduct.productId)"
                        type="text"
                        class="danger-text"
                        @click="clearProductCreative(currentConfigProduct.productId)"
                      >
                        清空当前素材
                      </el-button>
                    </div>
                  </div>

                  <div class="selected-material-panel" v-if="getSelectedCreative(currentConfigProduct.productId)">
                    <div class="material-preview-card">
                      <img :src="getSelectedCreative(currentConfigProduct.productId).selectedVideoCoverUrl || currentConfigProduct.productImage || currentConfigProduct.img" alt="">
                      <div class="preview-duration" v-if="getMaterialDuration(currentConfigProduct.productId)">
                        {{ getMaterialDuration(currentConfigProduct.productId) }}
                      </div>
                    </div>
                    <div class="material-form">
                      <div class="budget-label">素材标题</div>
                      <el-input
                        v-model.trim="promotionConfigSelectedCreativeMap[currentConfigProduct.productId].selectedTitle"
                        type="textarea"
                        :rows="3"
                        maxlength="100"
                        show-word-limit
                        placeholder="请输入素材标题"
                      ></el-input>
                      <div class="material-field-row">
                        <div class="material-field">
                          <div class="mini-label">视频ID</div>
                          <div class="mini-value">{{ getSelectedCreative(currentConfigProduct.productId).selectedVideoId }}</div>
                        </div>
                        <div class="material-field">
                          <div class="mini-label">素材ID</div>
                          <div class="mini-value">{{ getSelectedCreative(currentConfigProduct.productId).selectedMaterialId || '--' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-empty v-else description="当前商品还未选择素材"></el-empty>
                </div>
                <el-empty v-else description="请先选择商品"></el-empty>
              </div>

              <div class="manual-material-preview">
                <div class="preview-phone">
                  <div class="preview-phone-header">
                    <span>素材预览</span>
                    <span>{{ getProductStatusText(currentConfigProductId) }}</span>
                  </div>
                  <div class="preview-phone-body" v-if="currentConfigProduct">
                    <img
                      class="preview-cover"
                      :src="getPreviewCover()"
                      alt=""
                    >
                    <div class="preview-product">
                      <img :src="currentConfigProduct.productImage || currentConfigProduct.img" alt="">
                      <div>
                        <div class="preview-product-name">{{ currentConfigProduct.productName }}</div>
                        <div class="preview-product-id">商品ID：{{ currentConfigProduct.productId }}</div>
                      </div>
                    </div>
                    <div class="preview-title">
                      {{ getPreviewTitle() }}
                    </div>
                  </div>
                  <el-empty v-else description="暂无商品预览"></el-empty>
                </div>
              </div>
            </div>
          </div>

          <div class="step-card">
            <div class="step-header">
              <div class="step-index">4</div>
              <div>
                <div class="step-title">计划确认</div>
                <div class="step-subtitle">保存后会回写到批量账户列表，再统一提交创建</div>
              </div>
            </div>
            <div class="confirm-grid">
              <div class="confirm-item">
                <div class="confirm-label">投放方式</div>
                <div class="confirm-value">控成本投放</div>
              </div>
              <div class="confirm-item">
                <div class="confirm-label">素材模式</div>
                <div class="confirm-value">{{ promotionConfigForm.materialMode === 'MANUAL' ? '自选素材' : '自动素材' }}</div>
              </div>
              <div class="confirm-item">
                <div class="confirm-label">预算/ROI</div>
                <div class="confirm-value">{{ promotionConfigForm.dayBudget || '--' }} 元 / {{ promotionConfigForm.roiTarget || '--' }}</div>
              </div>
              <div class="confirm-item">
                <div class="confirm-label">已手动选择</div>
                <div class="confirm-value">{{ getConfiguredProductCount() }}/{{ promotionConfigProducts.length }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="promotion-config-footer">
          <el-button round @click="showPromotionConfigDrawer = false">取消</el-button>
          <el-button type="primary" round @click="savePromotionConfig">保存当前账户配置</el-button>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      :visible.sync="showMaterialDialog"
      width="72%"
      append-to-body
      class="material-dialog"
      title="选择视频素材"
    >
      <div class="material-dialog-toolbar">
        <div class="toolbar-left">
          <span class="dialog-product-name">{{ materialDialogProductName }}</span>
          <span class="dialog-product-id" v-if="materialDialogProductId">商品ID：{{ materialDialogProductId }}</span>
        </div>
        <div class="toolbar-right">
          <el-button type="text" @click="reloadMaterialOptions">重新加载</el-button>
        </div>
      </div>
      <el-tabs v-model="materialDialogSource" class="material-source-tabs" @tab-click="handleMaterialSourceChange">
        <el-tab-pane label="抖音号视频" name="DOUYIN_PRODUCT"></el-tab-pane>
        <el-tab-pane label="千川素材库" name="MATERIAL_LIBRARY"></el-tab-pane>
        <el-tab-pane label="上传并选用" name="NEW_UPLOAD"></el-tab-pane>
      </el-tabs>
      <div v-if="materialDialogSource === 'NEW_UPLOAD'" class="material-upload-panel">
        <div class="material-upload-panel__hint">上传会在后台异步处理；完成后自动选择到当前商品。仅支持 mp4、mpeg、3gp、avi，文件不超过 1000M；上传并选用的视频时长必须满足 300s≥时长≥4s。</div>
        <el-form label-width="90px" size="small" class="material-upload-panel__form">
          <el-form-item label="视频规格">
            <el-radio-group v-model="materialUploadSpec">
              <el-radio-button label="VIDEO_HORIZONTAL">横版 16:9</el-radio-button>
              <el-radio-button label="VIDEO_VERTICAL">竖版 9:16</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择文件">
            <el-upload
              action="#"
              :auto-upload="false"
              :limit="1"
              accept=".mp4,.mpeg,.3gp,.avi,video/mp4,video/mpeg,video/3gpp,video/x-msvideo"
              :file-list="materialUploadFileList"
              :on-change="handleMaterialUploadFileChange"
              :on-remove="handleMaterialUploadFileRemove"
            >
              <el-button size="small" type="primary">选择视频文件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="materialUploadLoading" @click="submitMaterialUpload">上传并选用</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else v-loading="materialDialogLoading" class="material-dialog-body">
        <el-empty
          v-if="!materialDialogLoading && !materialDialogList.length"
          :description="materialDialogSource === 'DOUYIN_PRODUCT'
            ? '当前商品暂无已同步的抖音号视频素材'
            : '本地素材库暂无可选视频；请先手动同步或上传素材'"
        ></el-empty>
        <div v-else class="material-dialog-grid">
          <div
            v-for="item in materialDialogList"
            :key="item.id"
            class="material-dialog-card"
            :class="{
              active: materialDialogSelectedVideoId === item.id,
              'is-disabled': shouldEnforceMaterialDuration() && !isMaterialSelectable(item)
            }"
            @click="selectMaterialOption(item)"
          >
            <div class="dialog-cover-wrapper">
              <img v-if="item.coverUrl" :src="item.coverUrl" alt="">
              <span v-else class="dialog-cover-placeholder">暂无封面</span>
              <div class="dialog-duration">{{ formatMaterialDuration(item) }}</div>
            </div>
            <div class="dialog-card-title">{{ item.title || item.filename || '未命名视频' }}</div>
            <div class="dialog-card-meta">
              {{ item.materialSubtype === 'VIDEO_VERTICAL' ? '竖版' : '横版' }} · 官方素材ID：{{ item.materialId || '--' }}
            </div>
            <div v-if="shouldEnforceMaterialDuration() && !isMaterialSelectable(item)" class="material-invalid-hint">
              {{ getMaterialInvalidReason(item) }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showMaterialDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmMaterialSelection">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import url from '@/utils/url'

export default {
  name: 'UniPromotionNew',
  components: { CommonTable },
  beforeDestroy() {
    this.clearPlanMaterialUploadPolling()
  },
  data() {
    return {
      pageSmall: false,
      route_params: {},
      loading: false,
      hasMore: false,
      productCursor: 0,
      currentTableIndex: null,
      productSearchText: '',
      productTableData: [],
      selectedList: [],
      saveSelectObj: {},
      savePromotionConfigObj: {},
      isSelect30: false,
      showSelectProductPopup: false,
      showPromotionConfigDrawer: false,
      showMaterialDialog: false,
      materialDialogLoading: false,
      materialDialogList: [],
      materialDialogSelectedVideoId: null,
      materialDialogSource: 'DOUYIN_PRODUCT',
      materialUploadSpec: 'VIDEO_HORIZONTAL',
      materialUploadFile: null,
      materialUploadFileList: [],
      materialUploadLoading: false,
      materialUploadPollTimer: null,
      materialUploadPollCount: 0,
      materialDialogProductId: null,
      materialDialogProductName: '',
      currentRowData: null,
      currentPromotionIndex: null,
      currentConfigProductId: null,
      promotionConfigProducts: [],
      promotionConfigSelectedCreativeMap: {},
      materialOptionMap: {},
      promotionConfigForm: {
        deliveryMode: 'COST',
        materialMode: 'AUTO',
        dayBudget: null,
        roiTarget: null,
        scheduleType: 'LONG_TERM',
        timeRange: []
      },
      searchs: [],
      permission: {
        update: 'uniPromotionTask:update',
        delete: 'uniPromotionTask:delete',
        deleteBatch: 'uniPromotionTask:deleteBatch'
      },
      url: {
        get: '/uniPromotionTask/listByCondition',
        add: '/uniPromotionTask/add',
        update: '/uniPromotionTask/update',
        delete2: '/uniPromotionTask/delete',
        delete_batch: '/uniPromotionTask/deleteBatch',
        status: '/uniPromotionTask/status'
      },
      tableColumns: [{
        field: 'account',
        label: '广告账户',
        show: true,
        account: true,
        width: '330'
      }, {
        field: 'dyNumber',
        label: '抖音号',
        sort: false,
        dyNumber: true,
        show: true,
        width: '330'
      }, {
        field: 'name',
        label: '商品组',
        sort: false,
        show: true,
        productGroup: true,
        width: '390'
      }, {
        field: 'editProductAction',
        label: '编辑商品',
        sort: false,
        show: true,
        editProductAction: true,
        width: '110'
      }, {
        field: 'promotionAction',
        label: '商品配置投放',
        sort: false,
        show: true,
        promotionAction: true,
        width: '130'
      }, {
        field: 'name',
        label: '整体ROI目标/日预算',
        sort: false,
        show: true,
        target: true
      }],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [{
          field: 'id',
          label: 'ID',
          type: 'input',
          add: false,
          update: true
        }, {
          field: 'agentId',
          label: 'agentId',
          type: 'input',
          placeholder: '请输入agentId',
          rules: [{ required: true, message: 'agentId不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'name',
          label: 'name',
          type: 'input',
          placeholder: '请输入name',
          rules: [{ required: true, message: 'name不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'type',
          label: 'type',
          type: 'input',
          placeholder: '请输入type',
          rules: [{ required: true, message: 'type不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'target',
          label: 'target',
          type: 'input',
          placeholder: '请输入target',
          rules: [{ required: true, message: 'target不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'uniPromotionNum',
          label: 'uniPromotionNum',
          type: 'input',
          placeholder: '请输入uniPromotionNum',
          rules: [{ required: true, message: 'uniPromotionNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'successNum',
          label: 'successNum',
          type: 'input',
          placeholder: '请输入successNum',
          rules: [{ required: true, message: 'successNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'waitNum',
          label: 'waitNum',
          type: 'input',
          placeholder: '请输入waitNum',
          rules: [{ required: true, message: 'waitNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'failNum',
          label: 'failNum',
          type: 'input',
          placeholder: '请输入failNum',
          rules: [{ required: true, message: 'failNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }]
      },
      operate: []
    }
  },
  computed: {
    filteredProductTableData() {
      const keyword = (this.productSearchText || '').trim().toLowerCase()
      if (!keyword) {
        return this.productTableData
      }
      return this.productTableData.filter((item) => {
        const productName = item.productName ? String(item.productName).toLowerCase() : ''
        const productId = item.productId ? String(item.productId).toLowerCase() : ''
        return productName.indexOf(keyword) !== -1 || productId.indexOf(keyword) !== -1
      })
    },
    currentConfigProduct() {
      if (!this.currentConfigProductId) {
        return null
      }
      return this.promotionConfigProducts.find((item) => String(item.productId) === String(this.currentConfigProductId)) || null
    },
    currentRowAccountName() {
      const row = this.currentRowData || {}
      return row.account && row.account.name ? row.account.name : '--'
    },
    currentRowDyName() {
      const row = this.currentRowData || {}
      if (row.selectedDYNumber && row.selectedDYNumber.name) {
        return row.selectedDYNumber.name
      }
      return '--'
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler() {
        if (this.$route.query.advertiserName || this.$route.query.id) {
          this.route_params = Object.assign({}, this.route_params, this.$route.query)
        }
      }
    }
  },
  methods: {
    isPageSmall(data) {
      this.pageSmall = data
    },
    cloneValue(value, defaultValue) {
      if (value === undefined || value === null) {
        return defaultValue
      }
      return JSON.parse(JSON.stringify(value))
    },
    normalizeProduct(item) {
      const product = this.cloneValue(item, {})
      product.productName = product.productName || product.productname || ''
      product.productname = product.productName
      product.productImage = product.productImage || product.img || ''
      product.img = product.img || product.productImage || ''
      const officialImage = this.selectOfficialProductImage(product)
      if (officialImage) {
        product.productImage = officialImage
        product.img = officialImage
      }
      return product
    },
    normalizeProductList(list) {
      if (!Array.isArray(list)) {
        return []
      }
      return list.map((item) => this.normalizeProduct(item))
    },
    mergeProductList(baseList, appendList) {
      const map = {}
      return this.normalizeProductList(baseList.concat(appendList)).filter((item) => {
        const key = item && item.productId ? String(item.productId) : ''
        if (!key) {
          return false
        }
        if (map[key]) {
          return false
        }
        map[key] = true
        return true
      })
    },
    normalizeSelectedCreativeMap(list) {
      const map = {}
      if (!Array.isArray(list)) {
        return map
      }
      list.forEach((item) => {
        if (item && item.productId) {
          map[item.productId] = this.cloneValue(item, {})
        }
      })
      return map
    },
    getAllBudgetFromRow(row) {
      const data = row && row.AllBudget ? row.AllBudget : {}
      return {
        dayBudget: data.dayBudget !== undefined ? Number(data.dayBudget) : null,
        roiTarget: data.roiTarget !== undefined ? Number(data.roiTarget) : null,
        scheduleType: data.scheduleType === false ? 'CUSTOM' : 'LONG_TERM',
        timeRange: data.startTime && data.endTime ? [data.startTime, data.endTime] : []
      }
    },
    rowClick(row) {
      this.$refs.prodcutTable.toggleRowSelection(row)
    },
    toggleRowSelection(item, index) {
      const row = this.productTableData.find((obj) => String(obj.productId) === String(item.productId))
      if (row) {
        this.$refs.prodcutTable.toggleRowSelection(row)
      }
      if (item.cursor > this.productCursor) {
        this.selectedList.splice(index, 1)
      }
    },
    selectChange() {
      this.selectedList = []
    },
    isCheckedChange(checked) {
      if (!this.$refs.prodcutTable) {
        return
      }
      this.filteredProductTableData.forEach((item, index) => {
        if (index < 30) {
          this.$refs.prodcutTable.toggleRowSelection(item, checked)
        }
      })
    },
    selectionChange(data) {
      const list = []
      data.forEach((item) => {
        if (item) {
          list.push(item)
        }
      })
      this.selectedList.forEach((item) => {
        if (item.cursor > this.productCursor) {
          list.push(item)
        }
      })
      const uniqueMap = {}
      this.selectedList = list.filter((item) => {
        if (!item || !item.productId || uniqueMap[item.productId]) {
          return false
        }
        uniqueMap[item.productId] = true
        return true
      }).slice(0, 30)
    },
    saveProduct(type) {
      if (type) {
        const selectedProducts = this.normalizeProductList(this.selectedList)
        const rowPatch = this.buildProductSelectionRowPatch(selectedProducts)
        this.saveSelectObj = {
          list: selectedProducts,
          index: this.currentTableIndex,
          rowPatch: rowPatch
        }
        if (this.showPromotionConfigDrawer && this.currentPromotionIndex === this.currentTableIndex) {
          this.syncPromotionProducts(selectedProducts)
        }
      }
      this.showSelectProductPopup = false
      this.selectedList = []
      this.productSearchText = ''
    },
    selectProduct(obj) {
      this.isSelect30 = false
      const scope = obj.scope || {}
      const index = obj.index
      const type = obj.type
      const rowData = scope.row || {}
      if (type) {
        this.selectedList = []
      }
      this.currentTableIndex = index
      this.currentRowData = rowData
      this.productTableData = rowData.isEdit
        ? this.mergeProductList([], rowData.editList || rowData.selectedList || [])
        : []
      this.productCursor = 0
      this.hasMore = false
      this.loading = true
      const advertiserId = rowData.account ? rowData.account.id : null
      const aweMeId = rowData.selectedDYNumber ? rowData.selectedDYNumber.id : null
      const list = this.showPromotionConfigDrawer && this.currentPromotionIndex === index
        ? this.promotionConfigProducts
        : (rowData.selectedList || [])
      this.showSelectProductPopup = true
      this.getTableData(advertiserId, aweMeId, list)
    },
    openProductDrawerFromConfig() {
      if (this.currentPromotionIndex === null) {
        return
      }
      const row = this.currentRowData || {}
      this.selectProduct({
        scope: { row: row },
        index: this.currentPromotionIndex,
        type: 0
      })
    },
    getProductTableHeight() {
      const viewportHeight = typeof window === 'undefined' ? 768 : window.innerHeight
      return Math.max(260, viewportHeight - 310)
    },
    loadMoreProducts() {
      const row = this.currentRowData || {}
      if (!this.hasMore || !row.account || !row.selectedDYNumber) {
        return
      }
      this.getTableData(row.account.id, row.selectedDYNumber.id, this.selectedList)
    },
    getTableData(advertiserId, aweMeId, list) {
      this.$axios.post({
        url: '/launchTheProduct/getListAvailableProducts',
        data: {
          advertiserId: advertiserId,
          aweMeId: aweMeId,
          cursor: this.productCursor || 0,
          notAll: true
        },
        success: (res) => {
          if (res.code === 0) {
            this.hasMore = !!res.hasMore
            if (res.cursor !== undefined && res.cursor !== null) {
              this.productCursor = res.cursor
            }
            if (Array.isArray(res.data)) {
              res.data.forEach((item) => {
                if (item.tag && typeof item.tag === 'string') {
                  item.tagArr = item.tag.slice(1, -1).split(/,\s*/)
                }
                item.cursor = this.productCursor || 0
              })
              this.productTableData = this.mergeProductList(this.productTableData, res.data)
            }
            this.loading = false
            if (list && list.length) {
              this.selectedList = this.normalizeProductList(list)
              this.$nextTick(() => {
                this.selectedList.forEach((item) => {
                  const row = this.productTableData.find((data) => String(data.productId) === String(item.productId))
                  if (row) {
                    this.$refs.prodcutTable.toggleRowSelection(row, true)
                  }
                })
              })
            }
          } else {
            this.loading = false
            this.$message.error(res.msg)
          }
        },
        error: () => {
          this.loading = false
          this.$message.error('商品加载失败')
        }
      })
    },
    openPromotionConfig(payload) {
      const scope = payload.scope || {}
      const index = payload.index
      const row = this.cloneValue(scope.row, {})
      this.currentPromotionIndex = index
      this.currentRowData = row
      this.promotionConfigProducts = this.normalizeProductList(row.selectedList || [])
      this.promotionConfigSelectedCreativeMap = this.normalizeSelectedCreativeMap(row.selectedCreatives || [])
      this.promotionConfigForm = Object.assign({
        deliveryMode: 'COST',
        materialMode: 'AUTO'
      }, this.getAllBudgetFromRow(row), {
        deliveryMode: row.deliveryMode || 'COST',
        materialMode: row.materialMode || 'AUTO'
      })
      if (this.isNoAwemeMerchant()) {
        this.promotionConfigForm.materialMode = 'AUTO'
        this.promotionConfigSelectedCreativeMap = {}
      }
      this.currentConfigProductId = this.promotionConfigProducts.length ? this.promotionConfigProducts[0].productId : null
      this.hydrateMaterialLibrarySelections()
      this.showPromotionConfigDrawer = true
    },
    hydrateMaterialLibrarySelections() {
      const row = this.currentRowData || {}
      if (!row.account || !row.account.id) {
        return
      }
      const pendingCreatives = Object.keys(this.promotionConfigSelectedCreativeMap)
        .map((key) => this.promotionConfigSelectedCreativeMap[key])
        .filter((creative) => creative && !creative.materialAssetId && !creative.selectedVideoId && creative.selectedMaterialId)
      if (!pendingCreatives.length) {
        return
      }
      this.$axios.get({
        url: '/oceanEngine/material/listByCondition',
        data: {
          advertiserId: row.account.id,
          materialType: 'VIDEO',
          materialChannel: 'QIANCHUAN_VIDEO',
          awemeId: null,
          pageIndex: 1,
          pageSize: 100
        },
        success: (res) => {
          if (res.code !== 0) {
            return
          }
          const page = res.data || {}
          const list = page.content || page.records || page.list || []
          pendingCreatives.forEach((creative) => {
            const asset = list.find((item) => item && item.id && String(item.materialId) === String(creative.selectedMaterialId))
            if (!asset) {
              return
            }
            this.$set(this.promotionConfigSelectedCreativeMap, creative.productId, Object.assign({}, creative, {
              materialAssetId: asset.id,
              selectionSource: 'MATERIAL_LIBRARY'
            }))
          })
        }
      })
    },
    switchConfigProduct(productId) {
      this.currentConfigProductId = productId
    },
    syncPromotionProducts(products) {
      const normalizedProducts = this.normalizeProductList(products)
      const validIds = normalizedProducts.map((item) => String(item.productId))
      const nextCreativeMap = {}
      Object.keys(this.promotionConfigSelectedCreativeMap).forEach((key) => {
        if (validIds.indexOf(String(key)) !== -1) {
          nextCreativeMap[key] = this.promotionConfigSelectedCreativeMap[key]
        }
      })
      this.promotionConfigProducts = normalizedProducts
      this.promotionConfigSelectedCreativeMap = nextCreativeMap
      if (!this.currentConfigProductId || validIds.indexOf(String(this.currentConfigProductId)) === -1) {
        this.currentConfigProductId = normalizedProducts.length ? normalizedProducts[0].productId : null
      }
    },
    buildProductSelectionRowPatch(selectedProducts) {
      const rowPatch = {
        selectedList: selectedProducts
      }
      if (this.showPromotionConfigDrawer && this.currentPromotionIndex === this.currentTableIndex) {
        this.syncPromotionProducts(selectedProducts)
        rowPatch.selectedCreatives = this.buildSelectedCreativeList()
      }
      return rowPatch
    },
    getSelectedCreative(productId) {
      if (!productId) {
        return null
      }
      return this.promotionConfigSelectedCreativeMap[productId] || null
    },
    hasSelectedCreative(productId) {
      return this.isCreativeComplete(this.getSelectedCreative(productId))
    },
    isDouyinCreative(creative) {
      return !!(creative && String(creative.selectionSource || '').toUpperCase() === 'DOUYIN_PRODUCT')
    },
    isNoAwemeMerchant() {
      const row = this.currentRowData || {}
      return !(row.selectedDYNumber && row.selectedDYNumber.id)
    },
    selectMaterialMode(mode) {
      if (mode === 'MANUAL' && this.isNoAwemeMerchant()) {
        this.promotionConfigForm.materialMode = 'AUTO'
        this.promotionConfigSelectedCreativeMap = {}
        this.$message.warning('无号商家仅支持商品卡投放，不能选择视频素材')
        return
      }
      this.promotionConfigForm.materialMode = mode
    },
    isCreativeComplete(creative) {
      if (!creative) {
        return false
      }
      if (creative.materialAssetId) {
        return this.isDouyinCreative(creative) || !!creative.selectedTitle
      }
      return !!(creative.selectedVideoId && creative.selectedAwemeItemId && creative.selectedTitle)
    },
    getProductStatusText(productId) {
      if (this.promotionConfigForm.materialMode !== 'MANUAL') {
        return '自动素材'
      }
      const creative = this.getSelectedCreative(productId)
      if (!creative) {
        return '自动匹配主页视频'
      }
      if (!creative.materialAssetId && !creative.selectedVideoId) {
        return '缺失视频'
      }
      if (!this.isDouyinCreative(creative) && !creative.selectedTitle) {
        return '缺失标题'
      }
      return '已配置'
    },
    getProductStatusClass(productId) {
      const text = this.getProductStatusText(productId)
      if (text === '已配置') {
        return 'status-success'
      }
      if (text === '自动素材' || text === '自动匹配主页视频') {
        return 'status-auto'
      }
      return 'status-warning'
    },
    getConfiguredProductCount() {
      if (this.promotionConfigForm.materialMode !== 'MANUAL') {
        return this.promotionConfigProducts.length
      }
      return this.promotionConfigProducts.filter((item) => {
        return this.isCreativeComplete(this.getSelectedCreative(item.productId))
      }).length
    },
    getPreviewCover() {
      const creative = this.getSelectedCreative(this.currentConfigProductId)
      if (creative && creative.selectedVideoCoverUrl) {
        return creative.selectedVideoCoverUrl
      }
      if (this.currentConfigProduct) {
        return this.currentConfigProduct.productImage || this.currentConfigProduct.img
      }
      return ''
    },
    getPreviewTitle() {
      const creative = this.getSelectedCreative(this.currentConfigProductId)
      if (creative && creative.selectedTitle) {
        return creative.selectedTitle
      }
      return '选择素材后将在这里预览标题'
    },
    getMaterialDuration(productId) {
      const list = Object.keys(this.materialOptionMap).reduce((items, key) => items.concat(this.materialOptionMap[key] || []), [])
      const creative = this.getSelectedCreative(productId)
      if (!creative || (!creative.materialAssetId && !creative.selectedVideoId)) {
        return ''
      }
      const matched = list.find((item) => String(item.id) === String(creative.materialAssetId || creative.selectedVideoId))
      return matched ? this.formatMaterialDuration(matched) : ''
    },
    openMaterialDialog(product) {
      if (!product) {
        this.$message.warning('请先选择商品')
        return
      }
      this.materialDialogProductId = product.productId
      this.materialDialogProductName = product.productName
      this.materialDialogSelectedVideoId = this.getSelectedCreative(product.productId)
        ? (this.getSelectedCreative(product.productId).materialAssetId || this.getSelectedCreative(product.productId).selectedVideoId)
        : null
      this.materialDialogSource = this.getSelectedCreative(product.productId)
        ? this.getSelectedCreative(product.productId).selectionSource || 'DOUYIN_PRODUCT'
        : 'DOUYIN_PRODUCT'
      this.showMaterialDialog = true
      this.loadMaterialOptions(product, false)
    },
    reloadMaterialOptions() {
      if (!this.currentConfigProduct || this.materialDialogSource === 'NEW_UPLOAD') {
        return
      }
      this.loadMaterialOptions(this.currentConfigProduct, true)
    },
    handleMaterialSourceChange() {
      this.materialDialogSelectedVideoId = null
      if (this.materialDialogSource !== 'NEW_UPLOAD' && this.currentConfigProduct) {
        this.loadMaterialOptions(this.currentConfigProduct, true)
      }
    },
    getMaterialOptionKey(productId) {
      return String(productId || '') + '_' + String(this.materialDialogSource || 'MATERIAL_LIBRARY')
    },
    loadMaterialOptions(product, forceReload) {
      if (this.materialDialogSource === 'NEW_UPLOAD') {
        this.materialDialogList = []
        return
      }
      const row = this.currentRowData || {}
      if (!row.account || !row.account.id) {
        this.$message.error('当前账户缺少广告主，无法加载素材')
        return
      }
      if (this.materialDialogSource === 'DOUYIN_PRODUCT' && (!row.selectedDYNumber || !row.selectedDYNumber.id)) {
        this.$message.error('请选择抖音号后再选择抖音号视频素材')
        return
      }
      const optionKey = this.getMaterialOptionKey(product.productId)
      if (!forceReload && this.materialOptionMap[optionKey] && this.materialOptionMap[optionKey].length) {
        this.materialDialogList = this.materialOptionMap[optionKey]
        return
      }
      this.materialDialogLoading = true
      if (this.materialDialogSource === 'DOUYIN_PRODUCT') {
        this.$axios.post({
          url: '/launchTheProduct/getProductCreativeList',
          data: {
            advertiserId: row.account.id,
            aweMeId: row.selectedDYNumber.id,
            productId: product.productId
          },
          success: (res) => {
            this.materialDialogLoading = false
            if (res.code !== 0) {
              this.materialDialogList = []
              this.$message.error(res.msg || '商品关联素材加载失败')
              return
            }
            const sourceList = res.data && Array.isArray(res.data.videoList) ? res.data.videoList : []
            const list = sourceList.map((item) => ({
              id: item.materialAssetId || item.videoId,
              materialAssetId: item.materialAssetId || '',
              materialId: item.materialId,
              videoId: item.videoId,
              awemeItemId: item.awemeItemId,
              title: item.title || item.materialId || '未命名视频',
              coverUrl: item.videoCoverUrl || '',
              contentUrl: item.videoUrl || '',
              materialSubtype: item.imageMode || 'VIDEO_VERTICAL',
              duration: item.duration,
              durationMillis: item.duration ? Number(item.duration) * 1000 : null
            })).filter((item) => item.id)
            this.$set(this.materialOptionMap, optionKey, list)
            this.materialDialogList = list
            if (!list.length) {
              this.$message.warning('当前商品暂无已同步的抖音号视频素材')
            }
          },
          error: () => {
            this.materialDialogLoading = false
            this.materialDialogList = []
            this.$message.error('商品关联素材加载失败')
          }
        })
        return
      }
      this.$axios.get({
        url: '/oceanEngine/material/listByCondition',
        data: {
          advertiserId: row.account.id,
          materialType: 'VIDEO',
          materialChannel: 'QIANCHUAN_VIDEO',
          awemeId: null,
          pageIndex: 1,
          pageSize: 100
        },
        success: (res) => {
          this.materialDialogLoading = false
          if (res.code === 0) {
            const page = res.data || {}
            const list = page.content || page.records || page.list || []
            this.$set(this.materialOptionMap, optionKey, list)
            this.materialDialogList = list
            if (!list.length) {
              this.$message.warning('本地素材库暂无可选视频')
            }
          } else {
            this.materialDialogList = []
            this.$message.error(res.msg || '素材加载失败')
          }
        },
        error: () => {
          this.materialDialogLoading = false
          this.materialDialogList = []
          this.$message.error('素材加载失败')
        }
      })
    },
    confirmMaterialSelection() {
      if (!this.materialDialogSelectedVideoId) {
        this.$message.warning('请先选择一条视频素材')
        return
      }
      const selectedOption = this.materialDialogList.find((item) => String(item.id) === String(this.materialDialogSelectedVideoId))
      if (!selectedOption) {
        this.$message.error('未找到对应素材，请重新选择')
        return
      }
      if (this.shouldEnforceMaterialDuration() && !this.isMaterialSelectable(selectedOption)) {
        this.$message.error(this.getMaterialInvalidReason(selectedOption) || '该素材不可选')
        return
      }
      const product = this.promotionConfigProducts.find((item) => String(item.productId) === String(this.materialDialogProductId))
      if (!product) {
        this.$message.error('商品信息已失效，请重新选择商品')
        return
      }
      this.applyMaterialSelection(product, selectedOption, this.materialDialogSource)
      this.showMaterialDialog = false
    },
    applyMaterialSelection(product, selectedOption, selectionSource) {
      if (!product || !selectedOption || !selectedOption.id) {
        this.$message.error('素材资产信息不完整，请重新选择')
        return
      }
      this.$set(this.promotionConfigSelectedCreativeMap, product.productId, {
        productId: product.productId,
        productName: product.productName,
        productImage: this.selectOfficialProductImage(product),
        selectionSource: selectionSource,
        materialAssetId: selectedOption.materialAssetId || (selectionSource !== 'DOUYIN_PRODUCT' ? selectedOption.id : ''),
        selectedVideoId: selectedOption.videoId || '',
        selectedAwemeItemId: selectedOption.awemeItemId || '',
        selectedImageMode: selectedOption.materialSubtype || '',
        selectedMaterialId: selectedOption.materialId || '',
        selectedTitle: selectedOption.title || selectedOption.filename || product.productName,
        selectedVideoCoverUrl: selectedOption.coverUrl || '',
        selectedVideoUrl: selectedOption.contentUrl || ''
      })
    },
    getMaterialDurationSeconds(item) {
      if (!item) {
        return NaN
      }
      const durationMillis = Number(item.durationMillis)
      if (!Number.isNaN(durationMillis) && durationMillis >= 0) {
        return durationMillis / 1000
      }
      const duration = Number(item.duration)
      return Number.isNaN(duration) ? NaN : duration
    },
    formatMaterialDuration(item) {
      const seconds = this.getMaterialDurationSeconds(item)
      if (!Number.isFinite(seconds)) {
        return '时长未知'
      }
      return `${Number(seconds.toFixed(2))}秒`
    },
    isMaterialDurationSelectable(item) {
      const seconds = this.getMaterialDurationSeconds(item)
      return Number.isFinite(seconds) && seconds >= 4 && seconds <= 300
    },
    isMaterialTitleSelectable(item) {
      const t = (item && (item.title || item.filename)) || ''
      return t.length > 0 && !t.includes('未命名')
    },
    isMaterialSelectable(item) {
      return this.isMaterialDurationSelectable(item) && this.isMaterialTitleSelectable(item)
    },
    getMaterialInvalidReason(item) {
      if (!this.isMaterialDurationSelectable(item)) return '不可选：视频时长须在 4s~300s 之间'
      if (!this.isMaterialTitleSelectable(item)) return '不可选：视频标题为空或含"未命名"，禁止投放'
      return ''
    },
    shouldEnforceMaterialDuration() {
      return this.materialDialogSource === 'DOUYIN_PRODUCT'
    },
    selectMaterialOption(item) {
      if (this.shouldEnforceMaterialDuration() && !this.isMaterialSelectable(item)) {
        this.$message.error(this.getMaterialInvalidReason(item) || '该素材不可选')
        return
      }
      this.materialDialogSelectedVideoId = item.id
    },
    getLocalVideoDuration(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const objectUrl = URL.createObjectURL(file)
        const cleanup = () => {
          URL.revokeObjectURL(objectUrl)
          video.removeAttribute('src')
          video.load()
        }
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
          const duration = Number(video.duration)
          cleanup()
          resolve(duration)
        }
        video.onerror = () => {
          cleanup()
          reject(new Error('无法读取视频时长'))
        }
        video.src = objectUrl
      })
    },
    async validateUploadMaterialDuration(file) {
      try {
        const duration = await this.getLocalVideoDuration(file)
        if (Number.isFinite(duration) && duration >= 4 && duration <= 300) {
          return true
        }
      } catch (e) {
        this.$message.error('无法读取视频时长，无法选择该视频')
        return false
      }
      this.$message.error('无法选择，视频时长范围：300s≥时长≥4s')
      return false
    },
    async handleMaterialUploadFileChange(file, fileList) {
      const raw = file && file.raw ? file.raw : null
      if (!raw) {
        return
      }
      const extension = String(raw.name || '').split('.').pop().toLowerCase()
      if (['mp4', 'mpeg', '3gp', 'avi'].indexOf(extension) === -1) {
        this.$message.error('仅支持 mp4、mpeg、3gp、avi 视频文件')
        this.materialUploadFile = null
        this.materialUploadFileList = []
        return
      }
      if (raw.size > 1000 * 1024 * 1024) {
        this.$message.error('视频文件不能超过 1000M')
        this.materialUploadFile = null
        this.materialUploadFileList = []
        return
      }
      if (!(await this.validateUploadMaterialDuration(raw))) {
        this.materialUploadFile = null
        this.materialUploadFileList = []
        return
      }
      this.materialUploadFile = raw
      this.materialUploadFileList = fileList.slice(-1)
    },
    handleMaterialUploadFileRemove() {
      this.materialUploadFile = null
      this.materialUploadFileList = []
    },
    createMaterialUploadRequestId() {
      return 'plan-material-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10)
    },
    async submitMaterialUpload() {
      const row = this.currentRowData || {}
      if (!row.account || !row.account.id) {
        this.$message.error('当前账户缺少广告主，无法上传素材')
        return
      }
      if (!this.materialUploadFile) {
        this.$message.warning('请选择需要上传的视频文件')
        return
      }
      if (!(await this.validateUploadMaterialDuration(this.materialUploadFile))) {
        return
      }
      this.$confirm('本次操作会真实上传视频到巨量引擎，确认继续吗？', '确认上传', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        const data = new FormData()
        const requestId = this.createMaterialUploadRequestId()
        data.append('advertiserId', row.account.id)
        data.append('clientRequestId', requestId)
        data.append('file', this.materialUploadFile)
        data.append('uploadMode', 'DIRECT_FILE')
        data.append('videoSpec', this.materialUploadSpec)
        data.append('isAigc', 'false')
        data.append('isGuideVideo', 'false')
        this.materialUploadLoading = true
        const xhr = new XMLHttpRequest()
        xhr.open('POST', url.reBase + '/trc20/qdd/manager/oceanEngine/material/upload/video')
        xhr.withCredentials = true
        const sessionId = (this.$store && this.$store.state && this.$store.state.sessionId) || ''
        if (sessionId) {
          xhr.setRequestHeader('Authorization', sessionId)
        }
        xhr.onload = () => {
          this.materialUploadLoading = false
          try {
            const res = JSON.parse(xhr.responseText || '{}')
            if ((res.code === 0 || res.code === 1) && res.data) {
              this.handlePlanMaterialUploadTask(res.data)
            } else {
              this.$message.error(res.msg || '视频上传任务提交失败')
            }
          } catch (e) {
            this.$message.error('视频上传响应解析失败')
          }
        }
        xhr.onerror = () => {
          this.materialUploadLoading = false
          this.$message.error('视频上传请求失败，请检查网络后重试')
        }
        xhr.send(data)
      }).catch(() => {})
    },
    handlePlanMaterialUploadTask(task) {
      if (!task) {
        return
      }
      if (task.state === 'SUCCESS') {
        this.selectUploadedMaterial(task)
        return
      }
      if (task.state === 'FAILED') {
        this.$message.error(task.lastErrorMessage || '视频上传失败')
        return
      }
      if (!task.clientRequestId) {
        this.$message.error('上传任务缺少客户端请求标识')
        return
      }
      this.$message.success('上传任务已创建，正在后台处理')
      this.startPlanMaterialUploadPolling(task.clientRequestId)
    },
    startPlanMaterialUploadPolling(clientRequestId) {
      this.clearPlanMaterialUploadPolling()
      this.materialUploadPollCount = 0
      this.pollPlanMaterialUploadTask(clientRequestId)
      this.materialUploadPollTimer = setInterval(() => this.pollPlanMaterialUploadTask(clientRequestId), 2000)
    },
    clearPlanMaterialUploadPolling() {
      if (this.materialUploadPollTimer) {
        clearInterval(this.materialUploadPollTimer)
        this.materialUploadPollTimer = null
      }
    },
    pollPlanMaterialUploadTask(clientRequestId) {
      const row = this.currentRowData || {}
      if (!clientRequestId || !row.account || !row.account.id) {
        return
      }
      this.materialUploadPollCount += 1
      if (this.materialUploadPollCount > 300) {
        this.clearPlanMaterialUploadPolling()
        this.$message.warning('上传任务仍在处理中，请稍后到素材库查看')
        return
      }
      this.$axios.get({
        url: '/oceanEngine/material/upload/task',
        data: { advertiserId: row.account.id, clientRequestId: clientRequestId },
        success: (res) => {
          if (res.code !== 0 || !res.data) {
            this.clearPlanMaterialUploadPolling()
            this.$message.error(res.msg || '上传任务查询失败')
            return
          }
          const task = res.data
          if (task.state === 'SUCCESS') {
            this.clearPlanMaterialUploadPolling()
            this.selectUploadedMaterial(task)
          } else if (task.state === 'FAILED') {
            this.clearPlanMaterialUploadPolling()
            this.$message.error(task.lastErrorMessage || '视频上传失败')
          }
        },
        error: () => {
          this.clearPlanMaterialUploadPolling()
          this.$message.error('上传任务查询失败')
        }
      })
    },
    selectUploadedMaterial(task) {
      const product = this.currentConfigProduct
      if (!product || !task || !task.materialAssetId) {
        this.$message.warning('上传已完成，请到千川素材库中手动选择视频')
        return
      }
      this.applyMaterialSelection(product, {
        id: task.materialAssetId,
        materialAssetId: task.materialAssetId,
        materialId: task.materialId,
        title: task.filename
      }, 'NEW_UPLOAD')
      this.materialUploadFile = null
      this.materialUploadFileList = []
      this.showMaterialDialog = false
      this.$message.success('视频上传完成，已选为当前商品素材')
    },
    clearProductCreative(productId) {
      if (!productId) {
        return
      }
      this.$delete(this.promotionConfigSelectedCreativeMap, productId)
    },
    getSquareImageUrls(product) {
      const squareImageList = product && product.squareImageList
      let imageList = []
      if (Array.isArray(squareImageList)) {
        imageList = squareImageList
      } else if (typeof squareImageList === 'string') {
        const value = squareImageList.trim()
        if (!value) {
          return []
        }
        if (value.charAt(0) === '[') {
          try {
            imageList = JSON.parse(value)
          } catch (e) {
            imageList = value.split(',')
          }
        } else {
          imageList = value.split(',')
        }
      }
      return imageList
        .map((item) => {
          if (typeof item === 'string') {
            return item.trim()
          }
          if (!item || typeof item !== 'object') {
            return ''
          }
          return String(
            item.finalUrl ||
              item.url ||
              item.imgUrl ||
              item.img_url ||
              item.imageUrl ||
              item.image_url ||
              ''
          ).trim()
        })
        .filter(Boolean)
    },
    isOfficialProductImageUrl(url) {
      return /^https:\/\/(?:[a-z0-9-]+\.)?ecombdimg\.com\//i.test(
        String(url || '').trim()
      )
    },
    selectOfficialProductImage(product) {
      const squareImageUrls = this.getSquareImageUrls(product)
      for (let index = 0; index < squareImageUrls.length; index += 1) {
        if (this.isOfficialProductImageUrl(squareImageUrls[index])) {
          return squareImageUrls[index]
        }
      }
      const primaryImage = product && (product.productImage || product.img)
      return this.isOfficialProductImageUrl(primaryImage) ? primaryImage : ''
    },
    buildSelectedCreativeList() {
      const productIds = this.promotionConfigProducts.map((item) => String(item.productId))
      return Object.keys(this.promotionConfigSelectedCreativeMap)
        .filter((key) => productIds.indexOf(String(key)) !== -1)
        .map((key) => {
          const creative = this.cloneValue(this.promotionConfigSelectedCreativeMap[key], {})
          const product = this.promotionConfigProducts.find((item) => String(item.productId) === String(key))
          if (product) {
            creative.productName = creative.productName || product.productName
            creative.productImage = this.selectOfficialProductImage(product)
          }
          return creative
        })
    },
    validatePromotionConfig() {
      if (!this.promotionConfigProducts.length) {
        this.$message.error('请先选择商品')
        return false
      }
      const imageMissingProduct = this.promotionConfigProducts.find(
        (product) => !this.selectOfficialProductImage(product)
      )
      if (imageMissingProduct) {
        this.$message.error(
          `商品ID：${imageMissingProduct.productId} 缺少可用于创建计划的官方商品方图，请重新加载商品后再试`
        )
        return false
      }
      if (!this.promotionConfigForm.dayBudget) {
        this.$message.error('请设置日预算')
        return false
      }
      if (Number(this.promotionConfigForm.dayBudget) < 300 || Number(this.promotionConfigForm.dayBudget) > 999999999.99) {
        this.$message.error('日预算必须在300-999999999.99之间')
        return false
      }
      if (!this.promotionConfigForm.roiTarget) {
        this.$message.error('请设置净成交ROI目标')
        return false
      }
      if (Number(this.promotionConfigForm.roiTarget) < 0.01 || Number(this.promotionConfigForm.roiTarget) > 10000) {
        this.$message.error('净成交ROI目标必须在0.01-10000之间')
        return false
      }
      if (this.promotionConfigForm.scheduleType === 'CUSTOM') {
        if (!Array.isArray(this.promotionConfigForm.timeRange) || this.promotionConfigForm.timeRange.length !== 2) {
          this.$message.error('请设置开始和结束时间')
          return false
        }
      }
      return true
    },
    savePromotionConfig() {
      if (this.isNoAwemeMerchant()) {
        this.promotionConfigForm.materialMode = 'AUTO'
        this.promotionConfigSelectedCreativeMap = {}
      }
      if (!this.validatePromotionConfig()) {
        return
      }
      const allBudget = {
        dayBudget: this.promotionConfigForm.dayBudget,
        roiTarget: this.promotionConfigForm.roiTarget,
        scheduleType: this.promotionConfigForm.scheduleType === 'LONG_TERM',
        startTime: this.promotionConfigForm.scheduleType === 'CUSTOM' ? this.promotionConfigForm.timeRange[0] : null,
        endTime: this.promotionConfigForm.scheduleType === 'CUSTOM' ? this.promotionConfigForm.timeRange[1] : null
      }
      this.savePromotionConfigObj = {
        index: this.currentPromotionIndex,
        rowPatch: {
          selectedList: this.cloneValue(this.promotionConfigProducts, []),
          AllBudget: allBudget,
          deliveryMode: this.promotionConfigForm.deliveryMode || 'COST',
          materialMode: this.promotionConfigForm.materialMode || 'AUTO',
          selectedCreatives: this.buildSelectedCreativeList()
        }
      }
      this.showPromotionConfigDrawer = false
      this.$message.success('当前账户配置已保存')
    }
  }
}
</script>

<style scoped>
.drawer_title {
  padding: 15px 25px;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
  background-color: #f7f9fc;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
}

/deep/ .row-pointer {
  cursor: pointer;
}

.product-drawer-body {
  position: relative;
  height: calc(100vh - 70px);
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.product-table-section {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-input {
  width: 360px;
}

.selected-counter {
  color: #606266;
  font-size: 13px;
}

.add_product_box img {
  height: 110px;
  width: 110px;
  border-radius: 10px;
  object-fit: cover;
}

.footer_box {
  font-size: 14px;
  position: static;
  flex-shrink: 0;
  width: 100%;
  height: 90px;
  box-shadow: 0 -4px 6px #00000014;
  padding: 5px 30px;
  box-sizing: border-box;
  background: #fff;
}

.selectedListBox {
  height: 90px;
  width: 700px;
  overflow: auto;
}

.footer_box img {
  cursor: pointer;
  height: 70px;
  width: 70px;
  border-radius: 10px;
  object-fit: cover;
}

.footer_box i {
  position: absolute;
  top: -3px;
  right: -3px;
  transform: scale(1.2);
  cursor: pointer;
}

/deep/ .header_className {
  background-color: #e4eeff !important;
}

/deep/ .el-checkbox__inner {
  border-radius: 4px;
}

.promotion-config-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 68px);
  background: linear-gradient(180deg, #f4f8ff 0%, #fbfcff 42%, #ffffff 100%);
}

.promotion-config-main {
  flex: 1;
  overflow: auto;
  padding: 24px;
}

.step-card {
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 14px 32px rgba(25, 74, 196, 0.08);
}

.step-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.step-index {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3f7cff 0%, #2864ea 100%);
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
}

.step-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2f56;
}

.step-subtitle {
  margin-top: 6px;
  color: #7081a6;
  font-size: 13px;
}

.account-summary,
.confirm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.summary-item,
.confirm-item {
  background: #f7faff;
  border-radius: 14px;
  padding: 14px 16px;
}

.summary-label,
.confirm-label,
.budget-label,
.mini-label {
  color: #7b8cb1;
  font-size: 13px;
}

.summary-value,
.confirm-value {
  display: block;
  margin-top: 6px;
  color: #203153;
  font-size: 16px;
  font-weight: 600;
}

.goods-toolbar {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.goods-tip,
.field-tip,
.editor-subtitle {
  color: #8b97b5;
  font-size: 12px;
}

.goods-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
}

.goods-card,
.manual-product-tab,
.material-dialog-card,
.delivery-mode-card,
.material-mode-card {
  border: 1px solid #e0e8ff;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.goods-card:hover,
.manual-product-tab:hover,
.material-dialog-card:hover,
.material-mode-card:hover {
  border-color: #5c8eff;
  box-shadow: 0 10px 24px rgba(55, 102, 231, 0.12);
}

.goods-card.active,
.manual-product-tab.active,
.material-dialog-card.active,
.delivery-mode-card.active,
.material-mode-card.active {
  border-color: #3f7cff;
  box-shadow: 0 14px 30px rgba(54, 102, 231, 0.16);
}

.material-mode-card.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.material-mode-card.disabled:hover {
  border-color: #e0e8ff;
  box-shadow: none;
}

.goods-card {
  display: flex;
  padding: 14px;
  gap: 14px;
}

.goods-card img,
.manual-product-tab img {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
}

.goods-card-content,
.manual-product-meta {
  min-width: 0;
  flex: 1;
}

.goods-name,
.manual-product-name,
.dialog-card-title,
.preview-product-name {
  color: #1f2f56;
  font-weight: 600;
  line-height: 1.5;
}

.goods-id,
.dialog-card-meta,
.preview-product-id,
.mini-value {
  margin-top: 6px;
  color: #7482a7;
  font-size: 12px;
  word-break: break-all;
}

.goods-status,
.manual-product-status {
  margin-top: 10px;
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: #fff6df;
  color: #c28b15;
}

.status-success {
  background: #eaf8ef;
  color: #1f9d57;
}

.status-auto {
  background: #edf3ff;
  color: #2f66d4;
}

.status-warning {
  background: #fff6df;
  color: #c28b15;
}

.delivery-mode-grid,
.material-mode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
}

.delivery-mode-card,
.material-mode-card {
  padding: 18px;
}

.delivery-mode-title,
.material-mode-title,
.editor-title {
  color: #213254;
  font-size: 16px;
  font-weight: 600;
}

.delivery-mode-desc,
.material-mode-desc {
  margin-top: 8px;
  color: #7180a5;
  font-size: 13px;
  line-height: 1.7;
}

.delivery-mode-card.disabled {
  opacity: 0.56;
  cursor: not-allowed;
  box-shadow: none;
}

.budget-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
}

.budget-item {
  background: #f8fbff;
  border-radius: 16px;
  padding: 18px;
}

.budget-input,
.time-range-picker {
  width: 100%;
  margin-top: 10px;
}

.schedule-block {
  margin-top: 20px;
}

.material-mode-grid {
  margin-bottom: 18px;
}

.auto-material-box {
  background: linear-gradient(135deg, #eef5ff 0%, #f7fbff 100%);
  border: 1px dashed #8bb4ff;
  border-radius: 16px;
  padding: 18px;
  color: #2e5fb9;
  display: flex;
  align-items: center;
  gap: 10px;
}

.manual-material-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 18px;
}

.manual-material-main,
.manual-material-preview {
  min-width: 0;
}

.manual-product-tabs {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.manual-product-tab {
  min-width: 220px;
  padding: 12px;
  display: flex;
  gap: 12px;
  background: #fff;
}

.material-editor {
  margin-top: 18px;
  border: 1px solid #e7ecff;
  border-radius: 18px;
  padding: 18px;
  background: #fcfdff;
}

.material-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.editor-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.danger-text {
  color: #f56c6c;
}

.selected-material-panel {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
}

.material-preview-card {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  background: #f2f6ff;
  min-height: 280px;
}

.material-preview-card img,
.preview-cover,
.dialog-cover-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-duration,
.dialog-duration {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(18, 22, 34, 0.72);
  color: #fff;
  font-size: 12px;
}

.material-form {
  min-width: 0;
}

.material-field-row {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.material-field {
  background: #f5f8ff;
  border-radius: 14px;
  padding: 14px;
}

.preview-phone {
  background: linear-gradient(180deg, #132743 0%, #203a62 18%, #f4f8ff 18%, #ffffff 100%);
  border-radius: 24px;
  padding: 16px;
  min-height: 500px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.preview-phone-header {
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 13px;
  margin-bottom: 16px;
}

.preview-phone-body {
  background: #fff;
  border-radius: 18px;
  padding: 14px;
}

.preview-cover {
  height: 260px;
  border-radius: 16px;
}

.preview-product {
  margin-top: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.preview-product img {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  object-fit: cover;
}

.preview-title {
  margin-top: 16px;
  padding: 14px;
  background: #f5f8ff;
  border-radius: 16px;
  color: #223355;
  line-height: 1.7;
  min-height: 88px;
}

.promotion-config-footer {
  padding: 18px 24px;
  background: #fff;
  box-shadow: 0 -8px 20px rgba(31, 53, 100, 0.08);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.material-dialog-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.material-source-tabs {
  margin: 0 0 12px;
}

.material-upload-panel {
  min-height: 280px;
  padding: 18px;
  border: 1px dashed #c9d8ff;
  border-radius: 12px;
  background: #f8faff;
}

.material-upload-panel__hint,
.dialog-cover-placeholder {
  color: #8490a8;
  font-size: 13px;
}

.material-upload-panel__form {
  margin-top: 18px;
}

.dialog-product-name {
  color: #1f2f56;
  font-weight: 600;
  margin-right: 12px;
}

.dialog-product-id {
  color: #7a89ad;
  font-size: 13px;
}

.material-dialog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.material-dialog-card {
  padding: 12px;
  background: #fff;
  cursor: pointer;
}

.material-dialog-card.is-disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.material-invalid-hint {
  margin-top: 6px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 18px;
}

.dialog-cover-wrapper {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #f4f8ff;
  height: 260px;
}

.dialog-card-title {
  margin-top: 12px;
  min-height: 42px;
}

@media screen and (max-width: 1200px) {
  .manual-material-layout,
  .selected-material-panel {
    grid-template-columns: 1fr;
  }

  .goods-toolbar,
  .material-editor-header,
  .material-dialog-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
